import { Plugin, PluginId } from "..";
import { defaultCommentBoxOptions } from "./comment-box-options";

const id: PluginId = "comment-box";

export const CommentBox: Plugin = {
	id,
	type: "history",
	header: {
		visible: false,
		edit: false,
		fullscreen: false,
	},
	name: "commentBox",
	component: defineAsyncComponent(() => import("./CommentBoxPlugin.vue")),
	config: defineAsyncComponent(() => import("./CommentBoxPluginConfig")),
	dataConfig: null,
	defaultDataResolver: () => undefined,
	defaultOptionsResolver: () => defaultCommentBoxOptions,
	dimension: {
		minHeight: 4,
		minWidth: 6,
	},

	currentVersion: 1,
	migrations: {},
};
